import { useMutation } from "react-query";

import {
  QUOTE_COMPARISON_DEFAULT_CRITERIA_KEY,
  setLocalStorageItem,
} from "../../helpers/localStorage";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { QuoteComparisonDefaultCriteria } from "./getQuoteComparisonDefaultCriteria";

export const setQuoteComparisonDefaultCriteria = (
  options: APQueryOptions = {}
) => {
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();
  const invalidateList = [["quote-comparison-default-criteria"]];

  return useMutation({
    mutationFn: (criteria: QuoteComparisonDefaultCriteria) => {
      setLocalStorageItem(QUOTE_COMPARISON_DEFAULT_CRITERIA_KEY, criteria);

      return Promise.resolve(true);
    },
    onError: defaultOnMutateError(options),
    onSettled: () => defaultOnMutateSettled(invalidateList),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
